import React, { useContext } from 'react'
import { FormContext } from './FormContext'
import Tooltip from 'components/common/tooltip/Tooltip'

interface SharingSectionProps {
  checkboxLabel: string
  tooltip: string
}

export const SharingSection: React.FC<SharingSectionProps> = ({ checkboxLabel, tooltip }) => {
  const { shouldShare, handleShareChange } = useContext(FormContext)

  const wrappedServerHtml = { __html: tooltip }
  // The old foundation tooltip would accept html markup as text
  // The new floating-ui tooltip requires regular markup so we need to convert the
  // text with embedded html from the server to actual markup.
  const tooltipContent = <div dangerouslySetInnerHTML={wrappedServerHtml} />
  const anchor = <span className='far fa-info-circle' />

  return (
    <div id='default_sharing_settings'>
      <div className='with-tooltip'>
        <span>Default Sharing Settings </span>
        <Tooltip anchor={anchor} content={tooltipContent} placement='right' />
      </div>
      <label className='checkbox-label'>
        <input
          type='checkbox' name='share_with_supplier' id='share_with_supplier'
          checked={shouldShare}
          onChange={handleShareChange}
        />
        <span>{checkboxLabel}</span>
      </label>
    </div>
  )
}
